import script from "./AutomationsPromoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AutomationsPromoBanner.vue?vue&type=script&setup=true&lang=js"

import "./AutomationsPromoBanner.vue?vue&type=style&index=0&id=b06849a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b06849a0"]])

export default __exports__